import { useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./home.scss";
import CenterDashboard from "./CenterDashboard";
import SuperAdminDashboard from "./SuperAdminDashboard";
import { RolesEnum } from "../../enum";

const Home = () => {
  const [token] = useState(localStorage.getItem("token"));

  // Parse role names safely
  const [roleNames] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("role_names")) || [];
    } catch {
      return [];
    }
  });

  const isSuperAdmin = roleNames.includes(RolesEnum.SUPER_ADMIN);
  console.log("Super Admin", roleNames, isSuperAdmin);

  const redirectToLogin = () => {
    alert("Please login first to access this page");
    window.location.href = "/";
  };

  return (
    <>
      {!token && redirectToLogin()}
      {token && (
        <div className="home">
          <Sidebar />
          <div className="homeContainer">
            <Navbar />
            <div className="dashboardContent">
              {isSuperAdmin ? (
                <SuperAdminDashboard token={token} />
              ) : (
                <CenterDashboard />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
